import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { toast } from "sonner";
import { Switch } from "../components/ui/switch";

export default function CreateRoom() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/rooms", { name, description, is_private: isPrivate });
      toast.success("Oda oluşturuldu!");
      navigate(`/watch/${data.slug}`);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#141414]">
      <Navbar />
      <div className="mx-auto max-w-lg px-4 py-16">
        <h1 className="text-4xl font-black text-white mb-2">Oda Oluştur</h1>
        <p className="text-gray-400 mb-8">Arkadaşlarını davet et, birlikte izlemeye başla.</p>
        <form onSubmit={submit} className="space-y-5 bg-[#181818] border border-white/10 rounded-xl p-6">
          <div>
            <label className="text-sm text-gray-300 mb-1.5 block">Oda Adı</label>
            <input data-testid="room-name-input" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Örn: Cuma Gecesi Film Keyfi"
              className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all" />
          </div>
          <div>
            <label className="text-sm text-gray-300 mb-1.5 block">Açıklama</label>
            <textarea data-testid="room-desc-input" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Bu odada ne izleyeceksiniz?" rows={3}
              className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all resize-none" />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-white">Gizli Oda</div>
              <div className="text-xs text-gray-500">Ana sayfada listelenmez, sadece link ile erişilir</div>
            </div>
            <Switch data-testid="room-private-switch" checked={isPrivate} onCheckedChange={setIsPrivate} />
          </div>
          {error && <p className="text-sm text-red-500">{error}</p>}
          <button data-testid="room-create-submit" type="submit" disabled={loading}
            className="w-full bg-[#E50914] hover:bg-[#F40612] text-white font-semibold py-3 rounded-md transition-all active:scale-95 disabled:opacity-60">
            {loading ? "Oluşturuluyor..." : "Odayı Oluştur"}
          </button>
        </form>
      </div>
    </div>
  );
}
